import { IconClipboardClose, IconHome, IconInvoice, IconList } from 'components/icons'

import {
  Box,
  Category,
  ClipboardTick,
  HomeHashtag,
  Like,
  Gift,
  LocationAdd,
  Setting,
  TableDocument,
} from 'iconsax-react'
import { ReactElement } from 'react'
import { UserRoleEnum } from '../generated/api'

const sizeIcon = 20

export interface IMainMenu {
  name: string
  slug: string
  icon: ReactElement
  submenuVisibility: boolean
  to: string
  submenus: ISubmenus[]
  roles: UserRoleEnum[]
}

interface ISubmenus {
  name: string
  slug: string
  to: string
  icon?: ReactElement
  submenuVisibility: boolean
}

export const MainMenu: IMainMenu[] = [
  {
    name: 'Pengambilan Pesanan',
    slug: 'pengambilan-pesanan',
    icon: <IconHome />,
    submenuVisibility: false,
    to: '/',
    submenus: [],
    roles: [UserRoleEnum.WarehouseOfficer],
  },
  {
    name: 'Daftar Pesanan',
    slug: 'orders-goods',
    icon: <IconList />,
    submenuVisibility: false,
    to: '/orders/goods',
    submenus: [],
    roles: [UserRoleEnum.Operation, UserRoleEnum.OperationLead],
  },
  {
    name: 'Daftar Persetujuan',
    slug: 'approvals',
    icon: <ClipboardTick />,
    submenuVisibility: false,
    to: '/approvals/list',
    submenus: [],
    roles: [UserRoleEnum.OperationLead],
  },
  {
    name: 'Daftar Pesanan Digital',
    slug: 'orders-digital',
    icon: <IconList />,
    submenuVisibility: false,
    to: '/orders/digital',
    submenus: [],
    roles: [UserRoleEnum.Operation],
  },
  {
    name: 'Daftar Invoice',
    slug: 'daftar-invoice',
    icon: <IconInvoice />,
    submenuVisibility: false,
    to: '/invoices/list',
    submenus: [],
    roles: [UserRoleEnum.FinanceAccountant, UserRoleEnum.FinanceLead],
  },
  {
    name: 'Konfirmasi Pembatalan',
    slug: 'orders-cancellation',
    icon: <IconClipboardClose />,
    submenuVisibility: false,
    to: '/orders/cancellation',
    submenus: [],
    roles: [UserRoleEnum.Operation],
  },
  {
    name: 'Inventaris',
    slug: 'inventori',
    icon: <Setting size={sizeIcon} />,
    submenuVisibility: false,
    to: '',
    submenus: [
      {
        name: 'Kelola Kategori',
        slug: 'kelola-kategori',
        submenuVisibility: false,
        icon: <Box size={sizeIcon} />,
        to: '/inventory/categories',
      },
      {
        name: 'Kelola Produk',
        slug: 'kelola-produk',
        submenuVisibility: false,
        icon: <Category size={sizeIcon} />,
        to: '/inventory/products',
      },
      {
        name: 'Daftar Vendor',
        slug: 'daftar-vendor',
        submenuVisibility: false,
        icon: <HomeHashtag size={sizeIcon} />,
        to: '/inventory/vendors',
      },
      {
        name: 'Kelola Lokasi',
        slug: 'kelola-lokasi',
        submenuVisibility: true,
        icon: <LocationAdd size={sizeIcon} />,
        to: '/inventory/stock-location',
      },
    ],
    roles: [UserRoleEnum.Operation],
  },
  {
    name: 'Daftar Voucher',
    slug: 'daftar-voucher',
    icon: <TableDocument size={sizeIcon} />,
    submenuVisibility: false,
    submenus: [],
    to: '/loyalty/vouchers',
    roles: [UserRoleEnum.Administrator],
  },
  {
    name: 'Daftar Pekerjaan',
    slug: 'job-vacancy',
    icon: <Like size={20} />,
    submenuVisibility: false,
    submenus: [],
    to: '/job-vacancy',
    roles: [UserRoleEnum.Administrator],
  },
  {
    name: 'Permintaan SawitPoin',
    slug: 'sawitpoin',
    icon: <TableDocument size={20} />,
    submenuVisibility: false,
    submenus: [],
    to: '/sawitpoin',
    roles: [UserRoleEnum.Administrator, UserRoleEnum.FinanceLead],
  },
  {
    name: 'Program Agen',
    slug: 'campaign',
    icon: <Gift size={20} />,
    submenuVisibility: false,
    submenus: [],
    to: '/campaign',
    roles: [UserRoleEnum.Administrator],
  },
]
